import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import BoxWrapper from 'components/atoms/BoxWrapper';
import DisabledTime from 'assets/img/disabled-time.svg';
import EnabledTime from 'assets/img/enabled-time.svg';
import WrapperFormControl from 'components/atoms/WrapperFormControl';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { colors } from 'theme/Variables';

const useStyles = makeStyles((theme) => ({
    menuPaper: {
        maxHeight: 280,
        marginTop: 50,
        borderRadius: 0,
    },
}));

const MenuItemWrapper = styled.div`
    border: 1px solid ${colors.primary['50']};
    border-radius: 10px;
    width: 100%;
    padding: 8px 10px;
`;

const StyledMenuItem = styled(MenuItem)`
    &:nth-child(odd) {
        ${MenuItemWrapper} {
            border: 0;
        }
    }
`;

const StyledSelect = styled(Select)`
    ${MenuItemWrapper} {
        border: 0;
    }
    img {
        display: none;
    }
`;

const FormControlSelectTime = ({
    instruction,
    name,
    label,
    value,
    handleChange,
    handleBlur,
    options,
}) => {
    const classes = useStyles();

    return (
        <WrapperFormControl name={name} instruction={instruction}>
            <FormControl fullWidth>
                <InputLabel htmlFor={name}>{label}</InputLabel>
                <StyledSelect
                    labelId={name}
                    id={name}
                    value={value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name={name}
                    MenuProps={{
                        classes: { paper: classes.menuPaper },
                    }}
                >
                    {options.map(({ time, label, availability }) => (
                        <StyledMenuItem key={time} value={time} disabled={availability}>
                            <MenuItemWrapper>
                                <BoxWrapper justifyContent="space-between">
                                    {label}
                                    <img
                                        src={availability ? DisabledTime : EnabledTime}
                                        alt="Time availability"
                                    />
                                </BoxWrapper>
                            </MenuItemWrapper>
                        </StyledMenuItem>
                    ))}
                </StyledSelect>
            </FormControl>
        </WrapperFormControl>
    );
};

export default FormControlSelectTime;
